/**
 * Serves WebP with PNG/JPEG fallback for public/ marketing assets (LCP / bandwidth).
 * @param {{ name: string, ext?: string, alt: string, className?: string, width?: number, height?: number, decoding?: 'async' | 'sync' | 'auto', responsiveWebpWidths?: number[], sizes?: string, [key: string]: unknown }} props
 */
export function PublicPictureImg({
  name,
  ext = 'png',
  alt,
  className,
  width,
  height,
  decoding = 'async',
  responsiveWebpWidths,
  sizes = '(max-width: 768px) 100vw, 860px',
  ...imgRest
}) {
  const fallback = `/${name}.${ext}`
  const webp = `/${name}.webp`
  const hasResponsive = Array.isArray(responsiveWebpWidths) && responsiveWebpWidths.length > 0
  const webpSrcSet = hasResponsive
    ? responsiveWebpWidths.map((w) => `/${name}-${w}.webp ${w}w`).join(', ')
    : webp

  return (
    <picture>
      <source type="image/webp" srcSet={webpSrcSet} {...(hasResponsive ? { sizes } : {})} />
      <img src={fallback} alt={alt} width={width} height={height} decoding={decoding} className={className} {...imgRest} />
    </picture>
  )
}
